import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as c from '../constant';
import * as actions from '../action';

function UpdateModal({
  createInput,
  updateRegion,
  formData,
  showLineBusiness,
  updateList,
  getRegionList,
  setFormData,
  history,
  id,
}) {
  const setModal = useContext(ModalContext);

  const handleOnSubmit = e => {
    e.preventDefault();
    updateRegion(id, formData, ({ data }) => {
      setModal({ isOpen: false });
      showLineBusiness(id);
      getRegionList();
      history.push(`/bpls/settings/linebusiness/${_.get(data, 'id')}`);
    });
  };

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onSetFormData = () => {
    if (!_.isEmpty(updateList)) {
      const args = {
        ...updateList,
      };
      setFormData(_.pick(args, _.keys(c.FORM_DATA)));
    }
  };

  useEffect(() => {
    onSetFormData();
  }, {});

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            {createInput({ key: 'name', label: 'Name:' }, { required: true })}
          </div>
          <div className="col-12 form-group">
            {createInput({ key: 'description', label: 'Description:' })}
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button type="submit" className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3">
            <span className="font-weight-bold">Submit</span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateModal.propTypes = {
  createInput: PropTypes.instanceOf(Function).isRequired,
  updateList: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  updateRegion: PropTypes.instanceOf(Function).isRequired,
  getRegionList: PropTypes.instanceOf(Function).isRequired,
  showLineBusiness: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  id: PropTypes.string.isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(UpdateModal);
